import {Directive, HostListener, Input} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
    selector: '[appValidateOnBlur]',
})
export class ValidateOnBlurDirective {

    @Input() appValidateOnBlur = true;

    constructor(private control: NgControl) { /* по this.control.control доступен FormControl */ }

    /**
     * Как только пользователь увел фокус с поля, валидируем поле
     */
    @HostListener('blur', ['$event'])
    onBlur() {
        if (this.appValidateOnBlur === false) {
            return;
        }

        const control = this.control.control;

        /**
         * Руками делаем поле dirty и touched, и валидируем
         */
        control.markAsTouched();
        control.markAsDirty();
        control.updateValueAndValidity();
    }
}
